export default __webpack_public_path__ + "static/media/1.91e6bba6.png";